import {MediaDetection, MediaDetectionType} from '@legit-health/ui';

/**
 * Computes the IHS4 score locally from a list of annotated detections.
 *
 * Formula:
 *   (number of nodules × 1)
 *   + (number of abscesses × 2)
 *   + (number of draining tunnels / fistulae / sinuses × 4)
 *
 * Computing it on the client keeps the displayed score in sync while the
 * practitioner adds or removes detections on the image. Detection types that
 * are not part of the formula (e.g. user-added `Lesion`) do not contribute.
 */
export default function calculateIhs4Score(detections: MediaDetection[]): number {
  return detections.reduce(function (score, detection) {
    if (detection.type === MediaDetectionType.Nodule) {
      return score + 1;
    }
    if (detection.type === MediaDetectionType.Abscess) {
      return score + 2;
    }
    if (detection.type === MediaDetectionType.DrainingTunnel) {
      return score + 4;
    }
    return score;
  }, 0);
}
